import { Component, DestroyRef, inject, Input, ViewChild } from '@angular/core';
import { TableColumn } from '@mynexus/mynexus-ui-lib';
import { Table } from 'primeng/table';
import { finalize } from 'rxjs/operators';
import { IGroupDTO, ISearchGroupDTOResults } from '@core/model';
import { GraphService } from '@core/services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-internal-user-groups',
    templateUrl: './internal-user-groups.component.html',
    styleUrls: ['./internal-user-groups.component.scss'],
    standalone: false
})
export class InternalUserGroupsComponent {
  private destroyRef = inject(DestroyRef);

  @ViewChild('dt', { static: true }) dataTable!: Table;

  @Input() set userId(value: string) {
    this.getUserGroups(value);
  }

  readonly defaultSortField = 'displayName';
  readonly defaultSortOrder = 1;

  isLoading = true;
  groups: IGroupDTO[] = [];
  totalRecords = 0;
  amountOfRows = 10;

  cols: TableColumn[];

  constructor(private graphService: GraphService) {
    this.cols = [
      new TableColumn('User Group', 'displayName', '20rem')
    ];
  }

  private getUserGroups(userId: string): void {
    this.isLoading = true;
    this.groups = [];

    this.graphService
      .getUserGroups(userId)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => this.isLoading = false)
      )
      .subscribe(
        (res: ISearchGroupDTOResults) => {
          if (res) {
            this.groups = res.items;
            this.totalRecords = this.groups.length;
          }
        }
      );

  }

}
